import { render, staticRenderFns } from "./layout-header-button.vue?vue&type=template&id=5dae184a&scoped=true&"
import script from "./layout-header-button.vue?vue&type=script&lang=js&"
export * from "./layout-header-button.vue?vue&type=script&lang=js&"
import style0 from "./layout-header-button.vue?vue&type=style&index=0&id=5dae184a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dae184a",
  null
  
)

export default component.exports